import {observer} from 'mobx-react';
import React from 'react';
import {X2AgeCategoryStore} from '../X2AgeCategoryStore';

@observer
export class AddLevelForm extends React.Component<{ store: X2AgeCategoryStore }> {
  render() {
    const {store} = this.props;

    if (store.addLevel === null)
      return null;

    const name = store.addLevel.name;
    return (
      <div className="row" key="add-form">
        <div className="col">
          <div className={name.formGroupClassName}>
            <input className="form-control" type="text"
                   value={name.value}
                   onChange={name.onChangeHandler}
                   onKeyDown={store.completeOnEnter}
                   onBlur={name.markTouched}/>
            <div className="invalid-text">Enter name</div>
          </div>
        </div>
      </div>);
  }
}
